import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * When the URL carries `?story=<id>` (e.g. from a link in the message feed),
 * scrolls that story's card into view and briefly highlights it. `ready` gates
 * the scroll until the stories have rendered, so the anchor element exists.
 *
 * Cards opt in by rendering `id={`story-${story.id}`}`. Returns the focused id so
 * a caller can, for instance, expand a collapsed section that contains it.
 */
export function useFocusStory(ready: boolean): string | null {
  const [params] = useSearchParams();
  const storyId = params.get('story');

  useEffect(() => {
    if (!storyId || !ready) return;
    const el = document.getElementById(`story-${storyId}`);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.classList.add('ring-2', 'ring-primary', 'ring-offset-2');
    const timer = setTimeout(
      () => el.classList.remove('ring-2', 'ring-primary', 'ring-offset-2'),
      2500,
    );
    return () => clearTimeout(timer);
  }, [storyId, ready]);

  return storyId;
}
